import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 4305 8949"
    {...props}
  >
    <path
      d="M2679 7983V2555C1669 3329 988 3717 638 3717c-167 0-316-68-444-200C63 3384 0 3230 0 3054c0-203 63-352 189-448 129-94 353-218 675-369 483-226 868-464 1155-715 290-251 544-532 768-841 222-312 369-502 436-573 68-71 196-108 384-108 209 0 381 82 507 245 128 163 191 387 191 674v6830c0 801-273 1200-819 1200-242 0-438-81-584-244-149-163-223-404-223-722z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
